@if (!isVideoClosed && isCargoAiDomain) {
  <div
    id="registration-video-wrapper"
    class="mt-4"
    (window:resize)="onResize()"
  >
    <video id="singleVideo" preload="auto" crossorigin controls>
      <source [src]="videoUrl" type="video/mp4" />
    </video>
  </div>
}
